import React from 'react';
import { useTheme } from '../contexts/ThemeContext.jsx';
import './ThemePicker.css';

export default function ThemePicker({ open, onToggle, onClose }) {
  const { themeId, setTheme, themes, isUnlocked } = useTheme();
  const current = themes.find(t => t.id === themeId) || themes[0];

  return (
    <div className="theme-picker-wrapper">
      <button className="theme-toggle" onClick={onToggle}>
        🎨
      </button>

      {open && (
        <>
          <div className="theme-backdrop" onClick={onClose} />
          <div className="theme-picker">
            {themes.map(t => {
              const unlocked = isUnlocked(t.id);
              const active = t.id === themeId;
              return (
                <button
                  key={t.id}
                  className={`theme-option ${active ? 'active' : ''} ${!unlocked ? 'locked' : ''}`}
                  onClick={() => {
                    if (unlocked) {
                      setTheme(t.id);
                      onClose();
                    }
                  }}
                >
                  <span className="theme-option-icon">{t.icon}</span>
                  <span className="theme-option-name">{t.name}</span>
                  {!unlocked && <span className="theme-option-lock">PRO</span>}
                  {active && <span className="theme-option-check">✓</span>}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
